import React from "react";
import styled from "styled-components";

const Parent = styled.div`
  background-image: url("space.jpg");
  overflow: hidden;
  width: 100vw;
  height: 100vh;
`;

const Iframe = styled.iframe`
  width: 100vw;
  height: 100vh;
  overflow: hidden;
`;

export default function SolarSystem() {
  return (
    <Parent>
      <Iframe
        title="Notre Système Solaire"
        frameborder="0"
        allowfullscreen
        mozallowfullscreen="true"
        webkitallowfullscreen="true"
        allow="autoplay; fullscreen; xr-spatial-tracking"
        xr-spatial-tracking
        execution-while-out-of-viewport
        execution-while-not-rendered
        web-share
        src="https://sketchfab.com/models/ce32c70038d440e1a579e411002158f6/embed"
      />
    </Parent>
  );
}
